import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./styles/tokens.css";
import "./index.css";
import { loadRuntimeConfig } from "./config/loadRuntimeConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function bootstrap() {
  await loadRuntimeConfig();
  const [{ default: App }, { I18nProvider }] = await Promise.all([
    import("./App"),
    import("./i18n/I18nContext"),
  ]);
  root.render(<I18nProvider><App /></I18nProvider>);
}

function iniciar() {
  root.render(<main style={{ padding: 24 }} role="status">Carregando configurações…</main>);
  bootstrap().catch(() => {
    root.render(<main style={{ padding: 24 }}><h1>Configuração indisponível</h1><p>Não foi possível carregar as configurações. Tente novamente em instantes.</p><button type="button" onClick={iniciar}>Tentar novamente</button></main>);
  });
}

iniciar();
